'use client';

import '@ui5/webcomponents/dist/Panel.js';
import { PanelAccessibleRole, TitleLevel } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `Panel` component is a container which has a header and a content area and is used for grouping and displaying information. It can be collapsed to save space on the screen.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/Panel" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const Panel = withWebComponent('ui5-panel', ['accessibleName', 'accessibleRole', 'headerLevel', 'headerText'], ['collapsed', 'fixed', 'noAnimation'], ['header'], ['toggle']);
Panel.displayName = 'Panel';
Panel.defaultProps = {
  accessibleRole: PanelAccessibleRole.Form,
  headerLevel: TitleLevel.H2
};
export { Panel };